// extracted by mini-css-extract-plugin
export var divider = "_46-0";
export var dividerText = "_46-1";